import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { selectIsMini } from '@shared/api/reduxToolkit';
import { i18TranslationNS, Translation } from '@shared/config/i18n';
import { useBrandTheme } from '@shared/lib/brandTheme';
import { TabButton } from '@shared/ui/tabButton';

export const Feedback = () => {
	const isMini = useSelector(selectIsMini);
	const { hideFeedback } = useBrandTheme();
	const { t: tT } = useTranslation(i18TranslationNS);

	const labels = {
		title: tT(Translation.FEEDBACK_TITLE),
		button: tT(Translation.FEEDBACK_BUTTON),
	};

	if (hideFeedback || isMini) return null;

	return (
		<div className='modal-cta'>
			<p className='modal-cta__heading body-semibold-base'>{labels.title}</p>

			<TabButton
				label={labels.button}
				className='modal-cta__button button-secondary button-secondary--basic button-secondary--icon-none'
				labelClassName='semantic-button-secondary'
			/>
		</div>
	);
};
